import { useQueryWithUserId } from '@northladder/services';

import { ITenantConfigOptions } from '../../tenants-api';

import { TENANT_CONFIG_API } from '../tenantAPIClient';

/**
 * This will be used to track the tenant config query.
 */
const TENANT_CONFIG_QUERY_KEY = 'tenant-config-query-key';

/**
 * This hook fetches the tenant config for the provided `identifier`.
 */
export const useTenantEnvironmentDetailsQuery = ({
  identifier,
  logoUrl,
}: ITenantConfigOptions) => {
  const { data, isError, error, isPending, isSuccess, refetch } =
    useQueryWithUserId({
      queryKey: [TENANT_CONFIG_QUERY_KEY, identifier],
      queryFn: () =>
        TENANT_CONFIG_API.fetchTenantConfig({
          identifier,
          logoUrl,
        }),
      retry: false,
      enabled: identifier.length > 7,
      refetchOnWindowFocus: false,
    });

  return {
    data,
    error,
    isError,
    isPending,
    isSuccess,
    refetch,
  };
};
